import { Personne } from "./personne";

export class Signature {
    id: number;
    libelle: string;
    personne: Personne;
}
